import { ComponentType } from '../../../../types/formulation';
import { datacorAppApi } from '../../../datacorAppApi';

const serviceUrl: string = 'componentType';

export const rdComponentTypeApi = datacorAppApi.injectEndpoints({
    endpoints: (build) => ({
        getComponentTypesForDropdown: build.query<
            { label: string; value: bigint }[],
            void
        >({
            query: () => serviceUrl,
            transformResponse: (response: ComponentType[]) => {
                return response.map((propType: ComponentType) => {
                    return {
                        label: propType.type,
                        value: propType.id,
                    };
                });
            },
            providesTags: ['FormulaStatus'],
        }),
    }),
});

export const { useGetComponentTypesForDropdownQuery } = rdComponentTypeApi;
